import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { CTAButton } from './CTAButton';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-navy-900 px-4 py-14 sm:px-6 sm:py-20" data-id="element-113" data-mp="1he2xs0gmtqg6">
      <div className="mx-auto max-w-2xl" data-id="element-114" data-mp="1cfjc815yagoc">
        <h2 className="text-center font-display text-3xl font-700 uppercase leading-tight text-white sm:text-4xl" data-id="element-115" data-mp="1ccdnwo55bito">
          Frequently asked questions
        </h2>

        <div className="mt-8 space-y-3" data-id="element-116" data-mp="254gu43692bgk">
          {faqs.map((faq, index) => {
          const isOpen = open === index;
          return <div key={faq.q} className="overflow-hidden rounded-xl border border-white/10 bg-navy-950" data-id="element-117" data-mp="1v4zqdrak67n8" data-mpi={index}>
                <h3 data-id="element-118" data-mp="opozdjlmss43">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-4 text-left transition-colors duration-150 ease-out hover:bg-navy-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-gold-400/60" data-id="element-119" data-mp="oq72n06po6li">
                    <span className="text-sm font-600 leading-snug text-white sm:text-base" data-id="element-120" data-mp="1fnuepis9tqmv">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-121" data-mp="11v5s678qrp1s" />
                  </button>
                </h3>
                {isOpen ? <p className="border-t border-white/10 px-4 py-4 text-sm leading-relaxed text-slate-300" data-id="element-122" data-mp="izfqkl4q0uof">
                    {faq.a}
                  </p> : null}
              </div>;
        })}
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-123" data-mp="2poq0aw4hwhc9">
          <CTAButton label="Get instant access — $27" subtext="One-time payment · Lifetime access · 7-day guarantee" data-id="element-124" data-mp="2kvna8xyxfq0t" />
        </div>
      </div>
    </section>;
}